import React, { useEffect, useState } from 'react';
import Drawer from 'Components/Drawer';
import EnvironmentManager from 'Utils/environmentManager';
import Input from 'Components/Input';
import { useDispatch, useSelector } from 'react-redux';
import {
  postOtp,
  updatePersonalInformationsPhone,
  getCommunicationSettings,
  ignoreSmsVerification
} from 'Store/actions';
import { numerize } from 'Utils/numerize';
import Otp from './Otp';
import Icon from 'Components/Icon';
import otpEnums from 'Utils/otpEnums';
import History from 'Store/history';
import PropTypes from 'prop-types';
import { withMixpanel } from 'Utils/mixpanel';

const STEPS = {
  CHOOSE_ADDRESS: 'CHOOSE_ADDRESS',
  NEW_PHONE: 'NEW_PHONE',
  OTP_CODE: 'OTP_CODE',
  CONTACT_PERMISSION: 'CONTACT_PERMISSION',
  BLACK_LIST_ERROR: 'BLACK_LIST_ERROR'
};

const PhoneNumberVerificationModal = ({ open, mixpanel }) => {

  const [permissionContent, setPermissionContent] = useState({
    content: '',
    title: '',
    buttonLabel: '',
    onClick: () => {}
  });

  const { data: { campaignEmail, campaignSms, campaignCallCenter }, isFetched: campaignInfoFetched } = useSelector(state => state.communicationSettings);

  const [drawerOpen, setDrawerOpen] = useState(open);

  const [phoneNumber, setPhoneNumber] = useState('');

  const [step, setStep] = useState(STEPS.CHOOSE_ADDRESS);

  const { data: { mobilePhoneNumber } } = useSelector(state => state.auth);

  const { otp: {
    data: otpData,
    error: otpError,
  } } = useSelector(state => state.membership);

  const dispatch = useDispatch();

  const [code, setCode] = useState('');

  const [otpTimeOver, setOtpTimeOver] = useState(false);
  let formattedNumber = mobilePhoneNumber?.length === 10 ?  `(${mobilePhoneNumber.slice(0, 3)})-${mobilePhoneNumber.slice(3, 6)}-${mobilePhoneNumber.slice(6, 8)}-${mobilePhoneNumber.slice(8)}` : mobilePhoneNumber;

  const CMS_TITLE_NUMBER_VALIDATION_ACTIONSHEET = EnvironmentManager.getMessageText({ key: 'title_number_validation_actionsheet' }) || 'Cep Telefonunu Doğrula';
  const CMS_DESC_TITLE_PHONE_VALIDATION_ACTION_SHET = EnvironmentManager.getMessageText({ key: 'description_number_validation_actionsheet' }) || 'Sistemde kayıtlı cep telefonunu hemen doğrula, en güncel fırsat ve kampanyaları kaçırma!';
  const CMS_DESC_NUMBER_VERIFIED_ACTIONSHEET = EnvironmentManager.getMessageText({ key: 'description_number_verified_actionsheet' })?.replace('%@', formattedNumber ? formattedNumber : '');
  const CMS_BUTTON_NEW_NUMBER_VALIDATION_CODE_ACTIONSHEET = EnvironmentManager.getMessageText({ key: 'button_new_number_validation_code_actionsheet' }) || 'Yeni Numara Gir';
  const CMS_BUTTON_NUMBER_UP_TO_DATE_VALIDATION_ACTIONSHEET = EnvironmentManager.getMessageText({ key: 'button_number_up_to_date_validation_actionsheet' }) || 'Numaram Güncel';
  const CMS_NUMBER_VALIDATION_BOX =  EnvironmentManager.getMessageText({ key: 'description_number_validation_box' }) || 'Cep Telefonu';
  const CMS_VALIDATION_LINK_ACTIONSHEET =  EnvironmentManager.getMessageText({ key: 'button_validation_actionsheet' }) || 'Aktivasyon Kodu Gönder';
  const CMS_DESC_NUMBER_VALIDATION_CODE_ACTIONSHEET =  EnvironmentManager.getMessageText({ key: 'description_number_validation_code_actionsheet' }) || 'Cep telefonuna yeni bir SMS onay kodu gönderdik. Hemen kodu gir ve onayla!';
  const CMS_BUTTON_CONFIRM_VALIDATION_CODE_ACTIONSHEET =  EnvironmentManager.getMessageText({ key: 'button_confirm_validation_code_actionsheet' }) || 'Onayla';
  const CMS_DESCRIPTION_TIME_IS_UP_CODE_ACTIONSHEET =  EnvironmentManager.getMessageText({ key: 'description_time_is_up_code_actionsheet' }) || "Süre doldu. SMS onay kodun ulaşmadıysa yeniden almak için Tekrar Gönder'e tıklayabilirsin.";
  const CMS_BUTTON_RESEND_VALIDATION_CODE_ACTIONSHEET =  EnvironmentManager.getMessageText({ key: 'button_resend_validation_code_actionsheet' }) || 'Tekrar Gönder';
  const CMS_DESCRIPTION_NUMBER_ONE_LAST_TRANSACTION_ACTIONSHEET =  EnvironmentManager.getMessageText({ key: 'description_number_one_last_transaction_actionsheet' });
  const CMS_BUTTON_CONTACT_PERMISSION =  EnvironmentManager.getMessageText({ key: 'button_contact_permission' }) || 'İletişim İzinlerini Düzenle';
  const CMS_TITLE_ONE_LAST_TRANSACTION_ACTIONSHEET =  EnvironmentManager.getMessageText({ key: 'title_one_last_transaction_actionsheet' }) || 'Son Bir İşlem Kaldı!';
  const CMS_DESCRIPTION_NUMBER_TRANSACTION_COMPLETE_ACTIONSHEET =  EnvironmentManager.getMessageText({ key: 'description_number_transaction_complete_actionsheet' });
  const CMS_TITLE_TRANSACTION_COMPLETE_ACTIONSHEET =  EnvironmentManager.getMessageText({ key: 'title_transaction_complete_actionsheet' }) || 'İşlem Tamam';
  const CMS_BUTTON_DONE_ACTIONSHEET =  EnvironmentManager.getMessageText({ key: 'button_done_actionsheet' }) || 'Tamam';
  const CMS_ERROR_VALIDATION_ACTIONSHEET =  EnvironmentManager.getMessageText({ key: 'description_error_validation_code_actionsheet' }) || 'Hatalı giriş yaptın. Telefonuna gelen SMS onay kodunu kontrol ederek tekrar deneyebilir misin?';
  const CMS_BLACKLIST_BUTTON = EnvironmentManager.getMessageText({ key: 'gsm_blacklist_actionsheet_button2' }) || 'Vazgeç';

  const [otpCodeContent, setOtpCodeContent] = useState({
    message: CMS_DESC_NUMBER_VALIDATION_CODE_ACTIONSHEET,
    error: ''
  });
  // Sadece hatalı kod (4022) durumunda OTP kutuları hata renginde gösterilir; kullanıcı kodu düzenleyince kalkar
  const [isCodeInvalid, setIsCodeInvalid] = useState(false);

  const onChange = e => {
    const phoneNumber = numerize(e.target.value);
    setPhoneNumber(phoneNumber);
  };

  const clearInput = () => {
    setPhoneNumber('');
  };

  const sendOtpCode = () => {
    dispatch(postOtp({ phoneNumber }, otpEnums.PHONE_NUMBER_UPDATE)).then(response => {
      if (response?.data?.code === 4086) {
        setStep(STEPS.BLACK_LIST_ERROR);
        setOtpCodeContent({
          error: '',
          message: response?.data?.message || 'Lütfen <b>0850 272 0 272</b> numaralı <b>müşteri hizmetleri</b>mizi arayın.',
        });
      } else {
        if (step !== STEPS.OTP_CODE) {
          setOtpCodeContent({
            message: CMS_DESC_NUMBER_VALIDATION_CODE_ACTIONSHEET,
            error: ''
          });
          setStep(STEPS.OTP_CODE);
        }
      }
    });
  };

  const onSubmitPhone = async () => {
    const formData = {
      mobilePhoneNumber: phoneNumber,
      needOtp: true,
      oneTimePassword: {
        referenceId: otpData?.referenceId,
        code: code,
      }
    };
    try {
      await dispatch(updatePersonalInformationsPhone(formData));
      setStep(STEPS.CONTACT_PERMISSION);

      if (!campaignCallCenter && !campaignEmail && !campaignSms && campaignInfoFetched) {
        mixpanel.track('View One Last Transaction Left Sheet');
      }

      mixpanel.track('Click Confirm Button', {
        'OTP Pass/Fail Status': 'true',
        'Confirmation Page': 'Validation Flow'
      });
    } catch (e) {
      if (e.response?.data?.code === 4022) {
        setIsCodeInvalid(true);
        setOtpCodeContent({
          error: CMS_ERROR_VALIDATION_ACTIONSHEET || e.response?.data?.message,
          message: '',
        });
      } else {
        setOtpCodeContent({
          error: e.response?.data?.message || 'Bir hata oluştu. Lütfen tekrar dene.',
          message: '',
        });

      }
      mixpanel.track('Click Confirm Button', {
        'OTP Pass/Fail Status': 'false'
      });
    }
  };


  useEffect(() => {
    if (mobilePhoneNumber) {
      const phoneNumber = numerize(mobilePhoneNumber);
      setPhoneNumber(phoneNumber);
    }
  }, [mobilePhoneNumber]);

  const phoneNumberIsValid = phoneNumber?.length == 10;
  const codeSubmitButtonIsDisabled = code?.length < 6 && !otpTimeOver;

  const onChangeOtpCodeHandler = value => {
    setCode(value);
    setIsCodeInvalid(false);
  };

  const onChangeTimeOverHandler = value => {
    setOtpTimeOver(value);
  };

  useEffect(() => {
    if (otpTimeOver) {
      setOtpCodeContent({
        message: CMS_DESCRIPTION_TIME_IS_UP_CODE_ACTIONSHEET,
        error: '',
      });
    } else {
      setOtpCodeContent({
        error: '',
        message: CMS_DESC_NUMBER_VALIDATION_CODE_ACTIONSHEET,
      });
    }

  }, [otpTimeOver]);


  useEffect(() => {
    if (step !== STEPS.BLACK_LIST_ERROR) {
      setOtpCodeContent({
        message: CMS_DESC_NUMBER_VALIDATION_CODE_ACTIONSHEET,
        error: ''
      });
    }
  }, [step]);

  useEffect(() => {
    if (!campaignInfoFetched)
      return;

    if (!campaignEmail && !campaignSms && !campaignCallCenter) {
      setPermissionContent({
        content: CMS_DESCRIPTION_NUMBER_ONE_LAST_TRANSACTION_ACTIONSHEET,
        title: CMS_TITLE_ONE_LAST_TRANSACTION_ACTIONSHEET,
        buttonLabel: CMS_BUTTON_CONTACT_PERMISSION,
        onClick: () => {
          History.push('/ayarlar/iletisim-izinleri');
          onCloseHandler();
          mixpanel.track('Click Edit Contact Permission Button');
        }
      });
    } else {
      setPermissionContent({
        content: CMS_DESCRIPTION_NUMBER_TRANSACTION_COMPLETE_ACTIONSHEET,
        title: CMS_TITLE_TRANSACTION_COMPLETE_ACTIONSHEET,
        buttonLabel: CMS_BUTTON_DONE_ACTIONSHEET,
        onClick: () => {
          mixpanel.track('View Completed Sheet');
          onCloseHandler();
        }
      });
    }
  }, [campaignInfoFetched, campaignEmail, campaignSms, campaignCallCenter]);

  const content = () => {
    switch (step) {
      case STEPS.BLACK_LIST_ERROR:
        return <div dangerouslySetInnerHTML={ { __html: otpCodeContent.message } } />;
      case STEPS.CHOOSE_ADDRESS:
        return <div className='phone-verification__chose-address' dangerouslySetInnerHTML={ { __html: CMS_DESC_NUMBER_VERIFIED_ACTIONSHEET } } />;
      case STEPS.NEW_PHONE:
        return <div className='phone-verification__new-email'>
          <div className='phone-verification__new-email__content' dangerouslySetInnerHTML={ { __html: CMS_DESC_TITLE_PHONE_VALIDATION_ACTION_SHET } } />
          <div className='phone-verification__new-email__input'>
            <Input
              name={ CMS_NUMBER_VALIDATION_BOX }
              id='phoneNumber'
              value={ phoneNumber }
              type='tel'
              mask='(599)-999-99-99'
              autoFocus
              onChange={ onChange }
              clearInput={ clearInput }
            />
          </div>
        </div>;
      case STEPS.OTP_CODE:
        return (
          <div className='phone-verification'>
            <div className='phone-verification__otp-title'>
              {
                otpCodeContent.error ? otpCodeContent.error : otpCodeContent.message
              }
            </div>
            {
              otpData
              && <Otp
                errorText={ otpError?.message }
                hasError={ isCodeInvalid }
                phone={ phoneNumber }
                otpData={ otpData }
                onChangeOtpCode={ onChangeOtpCodeHandler }
                onChangeTimeOver={ onChangeTimeOverHandler }
              />
            }
          </div>
        );

      case STEPS.CONTACT_PERMISSION: {
        return (<div className='phone-verification__contact' dangerouslySetInnerHTML={ { __html: permissionContent.content } } />);
      }
    }
  };


  const buttons = () => {
    switch (step) {
      case STEPS.CHOOSE_ADDRESS:
        return {
          primaryButton: {
            label: CMS_BUTTON_NUMBER_UP_TO_DATE_VALIDATION_ACTIONSHEET,
            onClick: () => {
              sendOtpCode();
              let obj = {};
              if (phoneNumber == mobilePhoneNumber) {
                obj = {
                  'Adjustment Status': phoneNumber == mobilePhoneNumber,
                  'Old GSM': mobilePhoneNumber,
                };
              } else {
                obj = {
                  'Adjustment Status': phoneNumber == mobilePhoneNumber,
                  'New GSM': phoneNumber
                };
              }

              mixpanel.track('Click Send Activation Code Button', obj);
            }
          },
          secondaryButton: {
            label: CMS_BUTTON_NEW_NUMBER_VALIDATION_CODE_ACTIONSHEET,
            onClick: () => {
              setStep(STEPS.NEW_PHONE);
            }
          },
        };
      case STEPS.NEW_PHONE:
        return {
          primaryButton: {
            label: CMS_VALIDATION_LINK_ACTIONSHEET,
            disabled: !phoneNumberIsValid,
            onClick: () => {
              sendOtpCode();
              let obj = {};
              if (phoneNumber == mobilePhoneNumber) {
                obj = {
                  'Adjustment Status': phoneNumber == mobilePhoneNumber,
                  'Old GSM': mobilePhoneNumber,
                };
              } else {
                obj = {
                  'Adjustment Status': phoneNumber == mobilePhoneNumber,
                  'New GSM': phoneNumber
                };
              }
              mixpanel.track('Click Send Activation Code Button', obj);
            },
            block: true,
          },
        };

      case STEPS.OTP_CODE:
        return {
          primaryButton: {
            label: otpTimeOver ? CMS_BUTTON_RESEND_VALIDATION_CODE_ACTIONSHEET : CMS_BUTTON_CONFIRM_VALIDATION_CODE_ACTIONSHEET,
            disabled: codeSubmitButtonIsDisabled,
            onClick: () => {
              if (otpTimeOver) {
                sendOtpCode();
                mixpanel.track('Click Resend Button');
              } else {
                onSubmitPhone();
              }
            }
          },
          secondaryButton: {
            label: CMS_BUTTON_NEW_NUMBER_VALIDATION_CODE_ACTIONSHEET,
            onClick: () => {
              setStep(STEPS.NEW_PHONE);
            }
          }
        };

      case STEPS.CONTACT_PERMISSION:
        return {
          primaryButton: {
            label: permissionContent.buttonLabel,
            onClick: () => {
              permissionContent.onClick();
            }
          }
        };

      case STEPS.BLACK_LIST_ERROR:
        return {
          primaryButton: {
            className: 'btn--primary',
            label: CMS_BLACKLIST_BUTTON,
            onClick: () => {
              onCloseHandler();
            }
          },
        };
    }
  };

  const icon = () => {
    switch (step) {
      case STEPS.OTP_CODE:
        if (otpCodeContent.error) {
          return <Icon iconName="svgAlert" />;
        } else {
          return <Icon iconName="svgThumpsUp" />;
        }
      case STEPS.BLACK_LIST_ERROR:
        return <Icon iconName="svgInfoCircleGreen" />;

      default:
        return null;
    }
  };

  const title = () => {
    switch (step) {
      case STEPS.CONTACT_PERMISSION:
        return permissionContent.title;
      case STEPS.BLACK_LIST_ERROR:
        return null;
      default:
        return CMS_TITLE_NUMBER_VALIDATION_ACTIONSHEET;
    }
  };

  const onCloseHandler = async () => {
    try {
      setDrawerOpen(false);
      dispatch(ignoreSmsVerification());
    } catch (error) {
      console.log('OTP ACTION SHEET INGORE PUT ERROR');
    }
  };

  useEffect(() => {
    if (!campaignInfoFetched) {
      dispatch(getCommunicationSettings());
    }
    mixpanel.track('View Validation Window');
  }, []);

  useEffect(() => {
    if (open) {
      setDrawerOpen(open);
    }
  }, [open]);


  return <Drawer onClose={ onCloseHandler } icon={ icon() } open={ drawerOpen } title={ title() } buttonArea={ buttons() }>
    { content() }
  </Drawer>;
};

PhoneNumberVerificationModal.propTypes = {
  open: PropTypes.bool,
  mixpanel: PropTypes.object,
};

export default withMixpanel(PhoneNumberVerificationModal);
